module.exports = __webpack_public_path__ + "static/share-d7f1b9ccb3a20de4ae953bca7e22c108.jpg";